<template>
  <section class="slopePage">
    <div class="container">
      <div class="row align-items-center justify-content-between flex-nowrap
                  slopePage__title-wrapper">
        <div class="slopePage__title slopePage__title-withBtn">
          Main slope area parameters
        </div>
        <button @click="showDeleteConfirmationModal()"
                class="delete__btn" v-if="this.allSlopes.length !== 1">
          <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 2.91667L18 5.29333M5.73105 3.60667L7.89615 1L12.1461 1.61333L13.349
            4.60333M12.467 12.1933L12.2264 19.5533M6.61321 12.1933L6.85377 19.63M1.56128
            7.74667H17.4386L16.6368 21.7C16.5566 22.9267 15.5141 24 14.2311 24H4.76883C3.40562 24
            2.44336 22.9267 2.36317 21.7L1.56128 7.74667Z" stroke="#999999" stroke-width="2"
                stroke-miterlimit="22.9256" stroke-linecap="round" stroke-linejoin="round">
          </path>
        </svg>
        </button>
      </div>
      <div class="row slopeForm slopePage__pane">
        <div class="col-12">
          <div class="slopePage__subtitle">
            Area shape
          </div>
        </div>
        <div class="col-12 slopeForm__box">
          <div v-for="item in slopeForms"
               :key="item.id"
               class="slopeForm__box-item">
            <label class="slopeForm__box-item__btn"
                  :for="item.value"
                  :class="{'slopeForm__box-item__btn--active':
                  slopeFromState.slopeForm === item.value}">
            <input type="radio"
                   :id="item.value"
                   :value="item.value"
                   v-model="slopeFromState.slopeForm"
                   class="slopeForm__box-item__btn__input"
                   @change="updateSlopeForm">
            <img :src="item.src"
                 :alt="item.value"
                 width="100%">
            </label>
          </div>
        </div>
      </div>
      <div class="row align-items-center figure__box slopePage__pane">
        <div class="col-12">
          <div class="slopePage__subtitle slopePage__subtitle-figure">
            Area size
          </div>
        </div>
        <div class="col-lg-4 col-md-4 slopePage__inputs-figure">
          <div v-for="(param, i) in slopeFromState.slopeParams" :key="i" class="input__params-box">
            <div class="input__box input__box-width">
              <span>Width, m</span>
              <input type="number"
                     placeholder=""
                     min="1"
                     max="1000"
                     :value="param.width"
                     @input="updateSlopeWidth"
                     class="input__box-input">
            </div>
            <div class="input__box input__box-height">
              <span>Valley, m </span>
              <input type="number"
                     placeholder=""
                     min="1"
                     max="1000"
                     :value="param.height"
                     @input="updateSlopeHeight"
                     class="input__box-input">
            </div>
            <div v-if="'bias1' in param" class="input__box input__box-bias1">
              <span>Shift<i></i><em>.</em> 1, m</span>
              <input type="number"
                     placeholder=""
                     min="0"
                     max="1000"
                     step="0.1"
                     :value="param.bias1"
                     @input="updateSlopeBias1"
                     class="input__box-input">
            </div>
            <div v-if="'bias2' in param" class="input__box input__box-bias2">
              <span>Shift<i></i><em>.</em> 2, m</span>
              <input type="number"
                     placeholder=""
                     min="0"
                     max="1000"
                     step="0.1"
                     :value="param.bias2"
                     @input="updateSlopeBias2"
                     class="input__box-input">
            </div>
            <div v-if="'biasHeight' in param" class="input__box input__box-biasHeight">
              <span>Shift<i></i><em>.</em> 1, m</span>
              <input type="number"
                     placeholder=""
                     min="0"
                     max="1000"
                     step="0.1"
                     :value="param.biasHeight"
                     @input="updateSlopeBiasHeight"
                     class="input__box-input">
            </div>
            <div v-if="'biasWidth' in param" class="input__box input__box-biasWidth">
              <span>Shift<i></i><em>.</em> 2, m</span>
              <input type="number"
                     placeholder=""
                     min="0"
                     max="1000"
                     step="0.1"
                     :value="param.biasWidth"
                     @input="updateSlopeBiasWidth"
                     class="input__box-input">
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 figure__box-right slopePage__figure-figure">
         <div class="figure__box-right__corners figure__box-right__corners--top"></div>
         <div class="figure__box-right__corners figure__box-right__corners--bottom"></div>
          <component
            :is="slopeFromState.slopeForm"
            :slopeParams="slopeFromState.slopeParams"
            :defaultSvgParams="defaultSvgParams">
          </component>
        </div>
      </div>
      <SimilarInputs :slope="slope" />
    </div>
  </section>
</template>

<script>

import Trapezoid from './figures/Trapezoid.vue';
import Square from './figures/Square.vue';
import ReverseTrapezoid from './figures/ReverseTrapezoid.vue';
import CornerLeftTop from './figures/CornerLeftTop.vue';
import CornerRightTop from './figures/CornerRightTop.vue';
import CornerLeftBottom from './figures/CornerLeftBottom.vue';
import CornerRightBottom from './figures/CornerRightBottom.vue';
import ErrorComponent from '../views/404.vue';
import SimilarInputs from './SimilarInputs.vue';


export default {
  props: {
    slope: Object,
  },
  data() {
    return {
      // slopeForm: this.slopeFromState.slopeForm,
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      slopeForms: [
        {
          id: 0,
          value: 'square',
          label: 'квадрат',
          src: require('@/assets/img/forms/square.svg'),
        },
        {
          id: 1,
          value: 'trapezoid',
          label: 'трапеция',
          src: require('@/assets/img/forms/trapezoid.svg'),
        },
        {
          id: 2,
          value: 'reverseTrapezoid',
          label: 'обратная трапеция',
          src: require('@/assets/img/forms/reverseTrapezoid.svg'),
        },
        {
          id: 3,
          value: 'cornerLeftTop',
          label: 'верхний левый угол',
          src: require('@/assets/img/forms/cornerLeftTop.svg'),
        },
        {
          id: 4,
          value: 'cornerRightTop',
          label: 'верхний правый угол',
          src: require('@/assets/img/forms/cornerRightTop.svg'),
        },
        {
          id: 5,
          value: 'cornerLeftBottom',
          label: 'нижний левый угол',
          src: require('@/assets/img/forms/cornerLeftBottom.svg'),
        },
        {
          id: 6,
          value: 'cornerRightBottom',
          label: 'нижний правый угол',
          src: require('@/assets/img/forms/cornerRightBottom.svg'),
        },
      ],
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    };
  },
  components: {
    Trapezoid,
    Square,
    ReverseTrapezoid,
    CornerLeftTop,
    CornerRightTop,
    CornerLeftBottom,
    CornerRightBottom,
    ErrorComponent,
    SimilarInputs,
  },
  methods: {
    updateSlopeForm() {
      this.$emit('updateSlopeForm', { id: this.slopeId, form: this.slopeFromState.slopeForm });
    },
    updateSlopeWidth(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeWidth', { id: this.slopeId, width: e.target.valueAsNumber });
      }
    },
    updateSlopeHeight(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeHeight', { id: this.slopeId, height: e.target.valueAsNumber });
      }
    },
    updateSlopeBias1(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeBias1', { id: this.slopeId, bias1: e.target.valueAsNumber });
      }
    },
    updateSlopeBias2(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeBias2', { id: this.slopeId, bias2: e.target.valueAsNumber });
      }
    },
    updateSlopeBiasHeight(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeBiasHeight', {
          id: this.slopeId,
          biasHeight: e.target.valueAsNumber,
        });
      }
    },
    updateSlopeBiasWidth(e) {
      if (!isNaN(e.target.valueAsNumber)) {
        this.$store.commit('updateSlopeBiasWidth', {
          id: this.slopeId,
          biasWidth: e.target.valueAsNumber,
        });
      }
    },
    showDeleteConfirmationModal() {
      this.$emit('showDeleteConfirmationModal');
    },
  },
  watch: {
  },
  async mounted() {
    // this.$store.dispatch('fetchPosts');
    // (this.$store.getters.isErrorLink) ? (this.slopeType = 'ErrorComponent',
    // this.isStratWindow = !this.isStratWindow) : this.slopeType = '';
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
.slopePage
  color: $black
  &__pane
    background: #fff
    border-radius: rem(4)
    padding: rem(34) 0
    +media((margin-bottom: (320: rem(16), 992: rem(34))))
    &-similar
      padding: rem(30) 0
    &--contr
      padding-bottom: rem(40)
  &__title
    font-style: normal
    font-weight: 500
    text-align: left
    +media((font-size: (320: rem(18), 992: rem(28))))
    +media((line-height: (320: rem(26), 992: rem(34))))
    +media((padding-left: (320: rem(24), 992: 0)))
    +media((padding-top: (320: rem(32), 992: rem(51))))
    +media((padding-bottom: (320: rem(22), 992: rem(51))))
    +media((padding-right: (320: rem(24), 992: 0)))
    &-wrapper
      .delete
        &__btn
          +media((margin-right: (320: rem(24), 992: 0)))
    &-withBtn
      +media((width: (320: calc(100% - 50px), 768: auto)))
  &__subtitle
    text-align: left
    font-style: normal
    font-weight: bold
    +media((font-size: (320: rem(14), 992: rem(18))))
    +media((line-height: (320: rem(17), 992: rem(22))))
    +media((margin-bottom: (320: rem(23), 992: rem(34))))
    +media((padding-left: (320: rem(9), 992: rem(25))))
    &-figure
      +media((order: (320: 1, 768: unset)))
  &__inputs
    &-figure
      +media((order: (320: 3, 768: unset)))
      +media((padding-bottom: (320: rem(22), 768: 0)))
      +media((padding-left: (768: rem(24), 992: rem(15))))
  &__figure
    &-figure
      +media((order: (320: 2, 768: unset)))
      +media((padding-top: (320: rem(38), 768: 0)))
      +media((padding-bottom: (320: rem(47), 768: 0)))
  .figure
    &__box
      +media((padding-right: (320: 0, 768: rem(24), 992: rem(40))))
      .slopePage__subtitle
        margin: 0
        +media((margin-bottom: (320: 0, 768: rem(-34))))
      &-right
        +media((padding-left: (320: rem(15), 768: rem(25))))
        &__corners
          position: absolute
          height: 100%
          width: 100%
          left: 0
          top: 0
          background: transparent
          pointer-events: none
          +media((display: (320: none, 768: block)))
          &--top, &--bottom
            &:before, &:after
              content: ""
              position: absolute
              height: rem(10)
              width: rem(10)
              background: transparent
              border-color: #D6D6D6
          &--top
            &:before
              top: 0
              left: rem(10)
              border-left: $corner-border
              border-top: $corner-border
            &:after
              top: 0
              right: 0
              border-right: $corner-border
              border-top: $corner-border
          &--bottom
            &:before
              bottom: 0
              left: rem(10)
              border-left: $corner-border
              border-bottom: $corner-border
            &:after
              bottom: 0
              right: 0
              border-right: $corner-border
              border-bottom: $corner-border
  .figure
    &__wrapper
      width: 100%
      svg
        width: 100%
        height: auto
.fading-enter-active, .fading-leave-active
  transition: opacity .5s

.fading-enter, .fading-leave-to
  opacity: 0
</style>
